import React from "react";

/**
 * Phase 10 — three-audience model: automotive | business | entrepreneur.
 * Single-audience: red AUTOMOTIVE / blue BUSINESS / amber ENTREPRENEUR.
 * Multi-audience: stacked compact pills inline. All-three collapses to ALL.
 */
const SLUG_META = {
  automotive:   { short: "AUTO",    long: "AUTOMOTIVE",   classes: "bg-fc-red/15 text-fc-red border-fc-red/40" },
  business:     { short: "BIZ",     long: "BUSINESS",     classes: "bg-[#3B82F6]/15 text-[#3B82F6] border-[#3B82F6]/40" },
  entrepreneur: { short: "FOUNDER", long: "ENTREPRENEUR", classes: "bg-[#F59E0B]/15 text-[#F59E0B] border-[#F59E0B]/40" },
};

const ALL_THREE_CLASS = "bg-white/10 text-white border-gray-300";

function basePillClass(extra = "") {
  return `inline-flex items-center text-[9px] font-black tracking-[0.15em] uppercase border px-1.5 py-0.5 rounded ${extra}`;
}

export default function AudiencePill({ audiences, size = "sm", testid }) {
  const list = Array.isArray(audiences) ? audiences.filter((s) => s in SLUG_META) : [];
  if (list.length === 0) return null;

  // Collapse to ALL when every known audience is present
  if (list.length === 3) {
    return (
      <span
        className={basePillClass(ALL_THREE_CLASS)}
        data-testid={testid || "audience-pill-all"}
      >
        ALL
      </span>
    );
  }

  // Single-audience: long label
  if (list.length === 1) {
    const meta = SLUG_META[list[0]];
    return (
      <span
        className={basePillClass(meta.classes)}
        data-testid={testid || `audience-pill-${list[0]}`}
      >
        {meta.long}
      </span>
    );
  }

  // 2-combo: stacked short pills
  return (
    <span className="inline-flex items-center gap-1" data-testid={testid || "audience-pill-multi"}>
      {list.map((s) => {
        const meta = SLUG_META[s];
        return (
          <span
            key={s}
            className={basePillClass(meta.classes)}
            data-testid={`audience-pill-${s}`}
          >
            {meta.short}
          </span>
        );
      })}
    </span>
  );
}
